import React from "react";

const PrivacyPolicy = () => {
  return <section className="py-5 fw-semibold">Privacy Policy...</section>;
};

export default PrivacyPolicy;
